var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('div',{staticClass:"wrapper"},[_c('NavBar'),_c('TweetDetail'),_c('Popular',{attrs:{"initial-popular":_vm.popularUpdate}})],1),_c('CreateTweets')],1)}
var staticRenderFns = []

export { render, staticRenderFns }